/** An enum of valid element types that is supported by this module */
export enum elementTypes {
  cardNumber = 'cardNumber',
  cardCvc = 'cardCvc',
  cardExpiry = 'cardExpiry',
}
